import React from 'react';

export function SettingsToggle({
  active,
  disabled,
  onClick,
  label,
}: {
  active: boolean;
  disabled?: boolean;
  onClick: () => void;
  label?: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={active}
      aria-label={label}
      onClick={onClick}
      disabled={disabled}
      className={`relative h-6 w-10 shrink-0 rounded-full transition-colors ${active ? 'bg-pipedrive-blue' : 'bg-slate-200'} disabled:cursor-not-allowed disabled:opacity-45`}
    >
      <span
        className={`absolute left-0.5 top-0.5 h-5 w-5 rounded-full bg-app-surface shadow-sm transition-transform ${
          active ? 'translate-x-4' : 'translate-x-0'
        }`}
      />
    </button>
  );
}
